import BelegButtonVersionsvergleichBetragsrechnerTableRow
  from "../../BelegButtonVersionsvergleichBetragsrechnerTableRow/BelegButtonVersionsvergleichBetragsrechnerTableRow.vue";
import FormElementReadOnly from "../../../../../../global/components/FormElement/FormElementReadOnly/FormElementReadOnly.vue";
import PuxTranslate from "../../../../../../global/components/PuxTranslate/PuxTranslate.vue";
import SnapshotIcon from "../../../../../Snapshot/SnapshotIcon/SnapshotIcon.vue";

import KumastaStandardfinanzierungrechner from "../../../../../KF/Betragsrechner/Kumasta/KumastaStandardfinanzierungrechner/KumastaStandardfinanzierungrechner";

// @vue/component
export default {
  name: "KumastaStandardfinanzierungrechnerBelegVergleich",
  components: {
    BelegButtonVersionsvergleichBetragsrechnerTableRow,
    FormElementReadOnly,
    PuxTranslate,
    SnapshotIcon,
  },
  mixins: [
    KumastaStandardfinanzierungrechner,
  ],
  props: {
    modelErfasst: {
      type: Object,
      required: true,
    },
    modelAnerkannt: {
      type: Object,
      required: true,
    },
  },
};
